import { Component } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { BadgeModule } from 'primeng/badge';
import { StyleClassModule } from 'primeng/styleclass';
import { RippleModule } from 'primeng/ripple';
import { MenuModule } from 'primeng/menu';
import { GlobalMessageService } from './global-services/global-message.service';
import { GlobalLoadingService } from './global-services/global-loading.service';
import { GlobalLoadingComponent } from './global-components/global-loading/global-loading.component';
import { GlobalSidebarComponent } from './global-components/global-sidebar/global-sidebar.component';
import { CommonModule } from '@angular/common';
import { LanguageService } from './global-services/language.service';
import { RecaptchaService } from './global-services/recaptcha.service';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    ButtonModule,
    ToastModule,
    GlobalLoadingComponent,
    InputTextModule,
    BadgeModule,
    StyleClassModule,
    ButtonModule,
    RippleModule,
    MenuModule,
    GlobalSidebarComponent,
  ],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'web-portal';
  showSidebar = true;

  private routerEventsSubscription: any;

  constructor(
    private globalMessageService: GlobalMessageService,
    private globalLoadingService: GlobalLoadingService,
    private router: Router,
    private languageService: LanguageService,
    private recaptchaService: RecaptchaService,
  ) {
    this.subscribeToRouterEvents();
  }

  ngOnInit(): void {
    this.recaptchaService.loadRecaptchaScript();
  }

  private subscribeToRouterEvents() {
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const isAcceptInviteRoute = event.urlAfterRedirects.includes('/accept-invite');
        const isSignInRoute = event.urlAfterRedirects.includes('/sign-in') || event.urlAfterRedirects.includes('/sign-up');
        const isFormFillRoute = event.urlAfterRedirects.includes('/form-fill');
        this.showSidebar = !isSignInRoute && !isAcceptInviteRoute && !isFormFillRoute;
      }
    });
  }

  ngOnDestroy() {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }

  showSuccess() {
    this.globalMessageService.showSuccess('Success', 'Operation completed successfully');
  }

  showLoading() {
    this.globalLoadingService.show();

    setTimeout(() => {
      this.globalLoadingService.hide();
    }, 2000); // Simulate a loading delay of 2 seconds
  }
}
